import { DataPrivacyViolationType } from '@monsido/ng2/modules/data-privacy/interfaces/data-privacy-violation.type';

// eslint-disable-next-line
export interface DataPrivacyViolationModel extends DataPrivacyViolationType {}

// eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging
export class DataPrivacyViolationModel {

    constructor (data: DataPrivacyViolationType) {
        Object.assign(this, data);
    }

}
